import { Link } from 'react-router-dom';
import img from '../img/katrina-wright-cropunsplash_450.jpg';
import levelUpTrish from '../img/Level-up Trish.png';
import levelUpAngie from '../img/Level-up Angie.png';
import SectionHead from '../components/SectionHead';
import Card from '../UI/Card';
import Frame from '../components/Frame';
import { blogSpot, highlightLinks, highlightVideo } from '../data/Data';

export default function Resources() {
  return (
    <div>
      <div className="hero-resource">
        <div id="hero">
          <img
            className="hero-img"
            src={img}
            alt="Photo credit: Katrina Wright via Unsplash"
            title="Photo credit: Katrina Wright via Unsplash"
          />
        </div>
      </div>

      <div className="container resources">
        <h1 className="page-title">Community Resources</h1><br />

        <div className="even-columns about p-flow">
        <h3>Aphasia Simulations</h3>
        <div className="card">
          <p>
            Aphasia Simulations developed by Dr. Hinckley at Nova University, and Keen Research.
            The purpose of these simulations is to provide some activities that can help you
            understand what it might be like to have aphasia:{' '}
            <span className="no_padding">
              <Link to="http://www.vohaphasia.org/simulation/" target="_blank" rel="noopener noreferrer">
                Aphasia Simulations
              </Link>.
            </span>
            <br />
          </p>
        </div>

        <h3>Supported Conversation for PWA (SCA™)</h3>
        <div className="card">
          <p>
            Developed by Aphasia Institute of Toronto
            <br />
            The goals of SCA™ are:
            <br />
            • Acknowledge the competence of the PWA. <br />
            • Help the PWA to reveal his or her competence. <br />
            •{' '}
            <Link
              to="https://www.aphasia.ca/family-and-friends-of-people-with-aphasia/family-sca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Talking to to your family member: Conversation Basics
            </Link>
            <br />
            <br />
            SCA™ is a communication method that uses a set of techniques to encourage conversation
            when working with PWA.{' '}
            <Link
              to="https://www.aphasia.ca/communication-tools-communicative-access-sca/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Supported Conversation tools
            </Link>.
          </p>
        </div>

        <h3>The Pictographs</h3>
        <div className="card">
          <p>
            ParticiPics is a free, searchable database of pictographic images designed to facilitate
            life's conversations. The pictographs are specially designed for communicating with PWA
            and the product of decades of research and experience with people in the aphasia and
            stroke communities.
            <br />
            ParticiPics is now hosted on the{' '}
            <Link
              to="https://www.aphasia.ca/participics/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aphasia Institute Community Hub
            </Link>.
          </p>
        </div>

        <div>
          <h3>Brain Friends Podcast</h3>
          <p>
            The Brain Friends podcast is a space for neuro nerds and stroke survivors to talk about
            all things aphasia, language recovery, and community. Hosted by Dr. D. Seles Gadson, a
            neuroscientist and speech-language pathologist, and Angie C., 2x stroke survivor and
            aphasia advocate. Listen, laugh, and learn with these two stakeholders determined to
            make a difference in aphasia advocacy.
            <br />
            Listen or download the podcast here:{' '}
            <Link
              to="https://podcasts.apple.com/us/podcast/brain-friends/id1631036407?i=1000658716836"
              target="_blank"
              rel="noopener noreferrer"
            >
              LINK
            </Link>
          </p>
        </div>

        <br />
        <h3>Aphasia Games for Health</h3>
        <div className="card">
          <p>
            A collaboration between professional game designers, academic speech pathologists and
            the aphasia community to develop games that best serve the needs of the aphasia
            community.
          </p>
          <ul>
            <li>The Ministers Cat: A memory and letter game for 2-6 players.</li>
            <li>Audition: A memory and improv-game.</li>
            <li>
              Do You See What I See: A video chat game for 4-16 players combining storytelling
              and 20 questions.
            </li>
          </ul>
          <p>
            Aphasia Community Recommendations:{' '}
            <Link
              to="https://www.aphasiagamesforhealth.com/community-recs"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aphasia Games for Health
            </Link>.
          </p>
        </div>

        </div>{/* even-columns */}

        {/* Living With Aphasia — moved from the old Highlight page */}
        <div className="highlight__container">
          <SectionHead
            title="Living With Aphasia"
            description="Watch the YouTube series produced by Boston University on the onset of Aphasia, its impact, and hopeful outcomes."
          />
          <div className="highlight__wrapper">
            {highlightLinks.map(({ id, title, description, path }, index) => (
              <Card className="highlights__highlight" key={id}>
                <h4>{title}</h4>
                <small>{description}</small>
                {highlightVideo[index] && (
                  <Frame
                    key={highlightVideo[index].id}
                    width="100%"
                    height="auto"
                    src={highlightVideo[index].src}
                    title={highlightVideo[index].title}
                    allow={highlightVideo[index].allow}
                    allowfullscreen={highlightVideo[index].allowfullscreen}
                    className={highlightVideo[index].className}
                  />
                )}
                <a href={path} target="_blank" rel="noopener noreferrer" className="btn sm">
                  YouTube
                </a>
              </Card>
            ))}
          </div>

          <SectionHead
            title="Blog Posts" className="blog__head"
            description="Check out this Vlog from a PWA."
          />
          {blogSpot.map(({ title, img, content, path }) => (
            <Card className="blog__card" key={title}>
              <img src={img} alt={title} className="centered" />
              <h3>{title}</h3>
              {content.map((text, i) =>
                text.split('{<br/>}').map((segment, j) => (
                  <p key={`${i}-${j}`}>{segment.trim()}</p>
                ))
              )}
              <a href={path} className="btn sm" target="_blank" rel="noopener noreferrer">
                Go to YouTube
              </a>
            </Card>
          ))}
        </div>

        {/* Community stories + Conversations — moved from the old Community page */}
          {/* YouTube — after newsletter grid */}
          <div className="youtube">
            <h3>
              Watch some of our community stories{' '}
              <a href="https://youtu.be/NUDQ3rdk1Wc?si=5Jl9bD2ytGrCDlXz" target="_blank" rel="noopener noreferrer">
                HERE
              </a>
            </h3>
            <iframe
              width="100%"
              height="360"
              style={{ maxWidth: '640px', aspectRatio: '16/9', height: 'auto' }}
              src="https://www.youtube.com/embed/NUDQ3rdk1Wc?si=etOo0LmnKU9K5KsV"
              title="NAS Aphasia Story - Michael Obel-Omia"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          {/* Conversations / UD ARO Lab */}
          <div className="extra">
            <h2 className="community color-blue">Conversations</h2>
            <p className="smaller">Click on the images below to go to UD ARO Lab YouTube channel.</p>
            <div className="extra-container">
              <div className="extra-grid">
                <a href="https://www.youtube.com/watch?v=EAF077vwPO0" target="_blank" rel="noopener noreferrer">
                  <img src={levelUpTrish} alt="podcast interview - Trish" />
                </a>
                <a href="https://www.youtube.com/watch?v=eToMijHBRPY" target="_blank" rel="noopener noreferrer">
                  <img src={levelUpAngie} alt="podcast interview - Angie" />
                </a>
              </div>
            </div>
            <p>
              The Aphasia &amp; Rehabilitation Outcomes (ARO) Lab at the University of Delaware
              researched post-stroke aphasia, a language impairment experienced by about 30% of
              stroke survivors. Aphasia impacts speech, understanding, reading, and writing, but not
              intelligence. It can be mild, moderate, or severe. Aphasia from stroke or other brain
              injury can improve with time, treatment, and determination. For more information,
              please visit us at UDAROLab.com.
              <br /><br />
              Check out the aphasia stories featuring PWA at the UD ARO Lab.{' '}
              <br />Please pass it along to your friends and family, or other people with aphasia.
            </p>
            <p>
              For more insightful interviews{' '}
              <a href="https://www.youtube.com/@UDAROLab" target="_blank" rel="noopener noreferrer">
                HERE https://www.youtube.com/@UDAROLab
              </a>:
            </p>
          </div>

      </div>{/* container */}
    </div>
  );
}
